package pages.stock

import api.ApiService
import components.routing.ProtectedRoutingProps
import csstype.pct
import api.dataclasses.stock.StockObject
import ics.utils.promise.launch
import mui.system.sx
import react.FC
import react.useEffect
import react.useState
import ics.materialUI.components.StyledBackDrop
import ics.materialUI.components.autoTable.AutoTable
import mui.material.*
import react.ReactNode
import kotlin.js.Date

val StockListPage = FC<ProtectedRoutingProps>("StockListPage") { props ->
    // state hooks
    val (dataState, setDataState) = useState<Array<StockObject>?>(null)
    val (errorMsgState, setErrorMsgState) = useState<String?>(null)

    // requests
    val getDataRequest: () -> Unit = {
        launch {
            val response = ApiService.getStockList(props.session, props.sessionSetter)

            if (response.success) {
                setErrorMsgState(null)
                setDataState(response.data)

                response.refreshedSession?.let {
                    props.sessionSetter(it)
                }

            } else {
                setErrorMsgState(response.errorMsg ?: "An unexpected error occurred")
            }
        }
    }


    // functions to be called after render
    useEffect{
        if (dataState == null && errorMsgState.isNullOrEmpty()) getDataRequest()
    }

    if (dataState != null) {
        Card {
            elevation = 3

            errorMsgState?.let{
                Alert {
                    severity = AlertColor.error
                    variant = AlertVariant.filled

                    sx {
                        width = 100.pct
                    }

                    + it
                }
            }

            AutoTable {
                tableData = dataState
                fieldsSequencedToShow = StockPageFieldMapping.headerSequence
                headers = StockPageFieldMapping.fieldMappings.english
                limit = 25
                limitOptions = arrayOf(25, 50, 100)
                search = true
                dense = true
                export = true
                exportFileName = "Stock-export-${Date(Date.now()).toISOString()}"
                exportButtonColor = ButtonColor.primary
            }
        }

    } else StyledBackDrop()

}